import { useCustomTranslation } from '../../../../../../hooks';
import { useAPI, PostBackReportsWorkstationsByLotProductionlotidStartRequest } from '@nexelem/api';
import { useMutation } from '@tanstack/react-query';
import { useCustomToast } from '@nexelem/snackbar';

export const useKanbanPendingToInProgressMutation = () => {
  const api = useAPI();
  const { tWrapper } = useCustomTranslation('components.toasts.commonMessage');
  const displayToast = useCustomToast();

  return useMutation({
    onSuccess: () => {
      displayToast({
        toastType: 'success',
        message: tWrapper('success'),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('error'),
      });
    },
    mutationFn: (data: PostBackReportsWorkstationsByLotProductionlotidStartRequest) =>
      api.postBackReportsWorkstationsByLotProductionlotidStart(data),
  });
};
